import { ResourceHeadersPropsWithActions } from 'modules/core/lib/navigation/types'

export const isValidMeta = <
  T extends Exclude<
    NonNullable<ResourceHeadersPropsWithActions['metadata']>[number],
    boolean | undefined | true
  >,
>(
  meta: undefined | T | boolean
): meta is T => !!meta && typeof meta !== 'boolean'
